import { CircularProgress, Grid, Typography, Box, Dialog, IconButton, Divider, DialogActions, DialogTitle, DialogContent } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DefaultContainer from "../components/DefaultContainer";
import DefaultHeader from "../components/DefaultHeader";
import MoneyFormat from "../components/MoneyFormat";
import { cancelOrder, getDetails } from "../services/Transactions";
import qs from "query-string";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import { getDetailReservation, cancelReservation } from "../services/Reservation";
import Button from "@mui/material/Button";
import { getAllByPartnerID } from "../services/Review";
import ls from "local-storage";
import moment from "moment";
import 'moment/locale/id';
import Overlay from "../components/Overlay";
import DefaultTextField from "../components/DefaultTextField";
import Toast from "../components/Snackbar";

export default function HistoryDetailScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [subtotal, setSubtotal] = useState("");
  const [specialDiscount, setSpecialDiscount] = useState(0);
  const [totalSpecialDisc, setTotalSpecialDisc] = useState(0);
  const [programDisc, setProgramDisc] = useState(0);
  const [programTitle, setProgramTitle] = useState("");
  const [charge, setCharge] = useState(0);
  const [totalCharge, setTotalCharge] = useState(0);
  const [service, setService] = useState(0);
  const [totalService, setTotalService] = useState(0);
  const [tax, setTax] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalAfterRounding, setTotalAfterRounding] = useState(0);
  const [time, setTime] = useState("");
  const [pmName, setPmName] = useState("");
  const [status, setStatus] = useState("0");
  const [createReview, setReview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [renderCounter, setRenderCounter] = useState(0)
  const [rounding, setRounding] = useState(0)
  const [overlayAccessDenied, setOverlayAccessDenied] = useState(false)
  const [bodyHeight, setBodyHeight] = useState(0)
  const [clickCancel, setClickCancel] = useState(false)
  const [openCancelNotes, setOpenCancelNotes] = useState(false)
  const [notes, setNotes] = useState("")
  const [toastOpen, setToastOpen] = useState(false)
  const [msg, setMsg] = useState("")
  const [toastStatus, setToastStatus] = useState(0)
  const [cancelConfirmation, setCancelConfirmation] = useState(false)
  const [promo, setPromo] = useState(0)
  const [trx, setTrx] = useState([])

  const bodyHeightRef = useRef()

  const disabledButton = {
    bgcolor: "gray",
    disabled: true, 
  }
  
  const enabledButton = {
    bgcolor: "#1FB0E6",
    disabled: false
  }

  async function cancelReservationF(id) {
    let data = {
      id:id
    }
     await cancelReservation(data).then((response)=>{
          if(response.success===1){
            setToastStatus(1)
            setMsg("Berhasil Membatalkan Reservasi")
            setTimeout(() => {
                setToastOpen(true);
            
                // Hide after 3 seconds (adjust timing as needed)
                setTimeout(() => {
                  setToastOpen(false);
                  navigate(-1)
                }, 1000);
            
              }, 300);
          }else{
            setToastStatus(0)
            setMsg(response.msg)
            setTimeout(() => {
              setToastOpen(true);
            
                // Hide after 3 seconds (adjust timing as needed)
                setTimeout(() => {
                  setToastOpen(false);
                }, 3000);
            
              }, 300);
          }
        })
  }

  const [buttonBehavior, setButtonBehavior] = useState(disabledButton)
  
  useEffect(() => {

    if(!ls.get("redux_localstorage_simple") || ls.get("sfToken") === null 
    || ls.get("sfToken").includes("dC9lNEx5UHNmb2VIWURoMzQrZDNvQmRGMVVpK2FZSkpaVDlMNUljYjl6b242SWtZK1RVd29ST1J1aUdEZEl3VjA2VFFLdDMzWkc4dmtvcjVJYURz")
    || ls.get("sfToken").includes("V2tDRTRkTXRJajhMTllJajdOY3pucWlKQXBLV1l2RGR1UWtwL3IyZVd5d2FQSXR6a0NCZTl3dE1FN1p0ZDlZK2tuSlJ1Y0RsWHI1Q3VsNHFCdWZqTFZzVzN3ZWZHR2lNUUt3K05ka1hSQjU1a1FVTDArMW14MWFkS2pweDRJa2ExR001SzFZcFJoTjB6T1ZSR3M3ZEtBPT0=")){
      return navigate('/auth',{state:{to:'/history'}})
    }

    if(renderCounter === 0){
      if(details?.isMembership === false)
        navigate("/membership",{state: details})
      else{
        fetchReview();
        // fetchDetails(query.transactionID);
      }
      if(bodyHeightRef){
        setBodyHeight(bodyHeightRef.current?.clientHeight)
      }
    }

    if(pmName === "PENDING" || status !== "2"){
      setButtonBehavior(disabledButton)
    }else{
      if(ls.get("sfReview") && renderCounter === 0){
        setButtonBehavior(ls.get("sfReview"))
      }
    }

    ls.set("sfReview", buttonBehavior)

    setRenderCounter(renderCounter + 1)


  }, [pmName, status]);

  const query = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  async function handleChangePaymentMethod(){
    let processData = trx
    processData.totalAfterRounding = totalAfterRounding 
    processData.paymentWay = "Change Method"
    processData.transactionID = query.transactionID
    navigate("/payment", {state: {...processData}})
  }

  async function handleCancelOrder(){
    const data = {
      transactionID: query.transactionID,
      status: 3, 
      cancel_notes: notes
    }

    const cancel = await cancelOrder(data)

    if(cancel.success === "1" || cancel.success === 1){
      setToastOpen(true)
      setToastStatus(cancel.success)
      setMsg(cancel.msg)
      setTimeout(()=>{
        navigate("/order")
      },1200)
    } else {
      setToastOpen(true)
      setToastStatus(cancel.success)
      setMsg(cancel.msg)
      setNotes("")
      setOpenCancelNotes(false)
      setCancelConfirmation(false)
      setClickCancel(false)
      setTimeout(()=>{
        setToastOpen(false)
      },1200)
    }

  }

  async function fetchReview() {
    setLoading(true); 
    await getAllByPartnerID(ls.get("partnerID"), query.transactionID).then((response) => {
      setReview(response["reviews"])

      setLoading(false);

      const filtered = response["reviews"].filter((item) => {
        return item.name === ls.get("redux_localstorage_simple").userData[ls.get("redux_localstorage_simple").userData.length - 1].name})

      if(filtered.length > 0){
        setButtonBehavior(disabledButton)
      }
      
      if(filtered.length === 0){
        setButtonBehavior(enabledButton)
      }
    });
  }

  const getDetailsReservation = async () =>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const id = urlParams.get('id')
    const response = await getDetailReservation(id, ls.get('sfPartner').id);
    return response
  }

useEffect(()=> {
  getDetailsReservation().then((res)=>
  setDetails(res.reservations[0]))
},[])

      // if(response.phone !== ls.get("redux_localstorage_simple").userData[ls.get("redux_localstorage_simple").userData.length - 1].phone){
      //   setButtonBehavior(disabledButton)
      //   setOverlayAccessDenied(true)
      // }

  return (
      overlayAccessDenied ? 
      <Overlay warning={true} routeToGo="/history" routeLabel="Kembali" message="Anda Tidak Memiliki Akses Di Transaksi Ini"/> :
      <DefaultContainer>
        <Toast isOpen={toastOpen} message={msg} status={toastStatus} />
        <Box p={2}>
          <DefaultHeader
            title={"Detail Reservasi"}
            url={`/history`}
          />    
            <Box display="flex" alignItems="center" p={2}>
              {/* Image Section */}
              <Box
                component="img"
                src={ls.get('sfPartner').img_map}
                alt="image-partner"
                sx={{
                  width: 60,  // Set fixed width
                  height: 60, // Set fixed height
                  borderRadius: 1, // Slightly rounded corners
                  objectFit: "cover", // Keep image aspect ratio
                  backgroundColor: "#000" // Match black background if needed
                }}
              />
              
              {/* Text Section */}
              <Box ml={2}>
                <Typography variant="h6" fontWeight="bold">
                  {ls.get('sfPartner')?.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {ls.get('sfPartner').address}
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            
            <Typography fontWeight="bold" mx={3}>Ringkasan Reservasi</Typography>
            <Typography mx={3}>{` <>`} ID Reservasi : {details?.id}</Typography>
            <Typography mx={3}>👤 {details?.persons} Orang</Typography>
            <Typography mx={3}>📅 {`${details?.reservation_time}`}</Typography>
            {details?.status==="Finished" ? 
                <Typography mx={3} fontWeight="bold" style={{color:"green"}}>
                  📃 Selesai
                </Typography>
              :details?.status==="Canceled_By_User" ?
              <Typography mx={3} fontWeight="bold" style={{color:"red"}}>📃 Dibatalkan Customer</Typography>
            :details?.status==="Canceled_By_Partner" ?
            <Typography mx={3} fontWeight="bold" style={{color:"red"}}>📃 Dibatalkan Merchant</Typography>
            : details?.status==="User_Not_Come" ? 
            <Typography mx={3} fontWeight="bold" style={{color:"red"}}>📃 Customer Tidak Datang</Typography>
            :details?.status==="Waiting_For_Approval" ? 
              <Typography mx={3} fontWeight="bold" color="#f1e560">
                📃 Menunggu Konfirmasi
              </Typography>
            : details?.status==="Approved" ? 
              <Typography mx={3} fontWeight="bold" color="green">📃 Disetujui</Typography>
            : details?.status==="Paid" ?
            <Typography mx={3} fontWeight="bold" color="green">📃 Dibayar</Typography>
            :<Typography mx={3} fontWeight="bold" color="#f1e560">📃 Pending</Typography>
            }

            <Typography mx={3}>🍽️ {`${details?.tableName}`}</Typography>
            <Typography mx={3}>Minimum Spend: <MoneyFormat value={details?.minimum_transaction}/></Typography>
            <Typography mx={3}>Booking Fee: Rp <MoneyFormat value={details?.booking_price}/></Typography>
            <Divider sx={{ my: 2 }} />

            
            <Typography mx={3} fontWeight="bold">Detail Pemesan</Typography>
            <Typography mx={3}>👤 Nama : {details?.name}</Typography> 
            <Typography mx={3}>📞 No. Telpon : {details?.phone}</Typography>
            <Typography mx={3}>📧 Email : {details?.email}</Typography>
            <Divider sx={{ my: 2 }} />

            <Typography mx={3} fontWeight="bold">Catatan Tambahan</Typography>
            {details?.description==="" ?<Typography mx={3}>-</Typography>:<Typography mx={3}>{details?.description}</Typography>}
            
            <Grid  sx={{display:"flex", alignItems:"center", justifyContent:"center", alignContent:"center"}}>
              {console.log(details)}
              <Button color="red" onClick={()=> setIsDialogOpen(!isDialogOpen)} sx={{display: (details?.status==="Pending" || details?.status==="Waiting_For_Approval" || details?.status==="Approved")? "block":"none"}}>Batalkan Reservasi</Button>
              {isDialogOpen &&
                <Dialog
                  
                  open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
                      <DialogTitle>Informasi</DialogTitle>
                      <DialogContent>
                          <Typography>Apakah anda yakin ingin membatalkan reservasi?</Typography>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={() => setIsDialogOpen(false)} color="primary">
                              Tutup
                          </Button>
                          <Button onClick={() => cancelReservationF(details.id)} color="secondary">
                              Batalkan Reservasi
                          </Button>
                      </DialogActions>
                  </Dialog>
              }
            </Grid>
        </Box>
        
      </DefaultContainer>
  );
}

